import { WashhubInventory } from 'types/washhub';
import { convertUTCToLocal } from 'utils/dateUtils';
import * as yup from 'yup';

import { equipmentCountSchema } from 'components/modules/EquipmentCountSection';

export const initialValues = (count: WashhubInventory | null) => {
  if (!count) {
    return {};
  }

  const sortedFullPackages = count.fullPackages?.sort((a: any, b: any) => {
    return a.skuName.localeCompare(b.skuName);
  });

  const sortedInBoxes = count.inBoxes?.sort((a: any, b: any) => {
    return a.skuName.localeCompare(b.skuName);
  });

  const sortedInProcess = count.inProcess?.sort((a: any, b: any) => {
    return a.skuName.localeCompare(b.skuName);
  });

  return {
    washHub: count?.washHub || '',
    date: count?.date ? convertUTCToLocal(count?.date, true, true) : '',
    fullPackages: sortedFullPackages.map((sku: any) => ({
      sku: sku.sku,
      skuName: sku.skuName,
      caseCount: sku.caseCount,
      totalItems: sku.totalItems,
      totalQuantity: sku.quantity,
      items: sku.items,
    })),
    inBoxes: sortedInBoxes.map((item: any) => ({
      sku: item.sku,
      skuName: item.skuName,
      boxCount: item.boxCount,
      itemsPerBox: item.itemsPerBox,
      totalItems: item.totalItems,
    })),
    inProcess: sortedInProcess.map((item: any) => ({
      sku: item.sku,
      skuName: item.skuName,
      itemCount: item.itemCount,
    })),
    equipment: (count.equipment || []).map((row) => ({
      sku: row.sku,
      skuName: row.skuName || '',
      itemCount: row.itemCount,
    })),
    notes: count?.notes,
  };
};

export const validationSchema = yup.object().shape({
  notes: yup.string().required('Notes is required'),
  date: yup.string().required('Count Date is required'),
  washHub: yup.string().required('Wash Hub is required'),
  fullPackages: yup.array().of(
    yup.object().shape({
      caseCount: yup.number().required('Case Count is required'),
    }),
  ),
  inBoxes: yup.array().of(
    yup.object().shape({
      boxCount: yup.number().required('Box Count is required'),
      itemsPerBox: yup.number().required('Items Per Box is required'),
    }),
  ),
  inProcess: yup.array().of(
    yup.object().shape({
      itemCount: yup.number().required('Item Count is required'),
    }),
  ),
  equipment: equipmentCountSchema,
});
